export default {
      id: "uspCard-savingLifeCover-usage",
      viewBox: "0 0 200 52",
      url: __webpack_public_path__ + "sprite.svg#uspCard-savingLifeCover",
      toString: function () {
        return this.url;
      }
    }